let RestData = [
  [
    
    {
     id:0,
    link: "/influencer/testimonial",
    imgLink:
    "https://images.unsplash.com/photo-1640289753542-b02666f4a664?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8Nnw0NTE3OTE2fHxlbnwwfHx8fA%3D%3D&auto=format&fit=crop&w=700&q=60",
    influencerTitle: "Twitch Q1"
  },
  {
    id:0,
    link: "/influencer/testimonial",
    imgLink:
      "https://images.unsplash.com/photo-1534008757030-27299c4371b6?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxleHBsb3JlLWZlZWR8Nnx8fGVufDB8fHx8&auto=format&fit=crop&w=700&q=60",
    influencerTitle: "Clan Q2"
  },
  {
    id:0,
    link: "/influencer/testimonial",
    imgLink:
      "https://images.unsplash.com/photo-1615332859295-aa9dc9f01fbc?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxleHBsb3JlLWZlZWR8NXx8fGVufDB8fHx8&auto=format&fit=crop&w=700&q=60",
    influencerTitle: "WBHI"
  }
],
[
   
  {
   id:1,
  link: "/influencer/testimonial",
  imgLink:
    "https://images.unsplash.com/photo-1640327866024-d06817d25393?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxleHBsb3JlLWZlZWR8MTN8fHxlbnwwfHx8fA%3D%3D&auto=format&fit=crop&w=700&q=60",
  influencerTitle: "Twitch Q1"
},
{
  id:1,
  link: "/influencer/testimonial",
  imgLink:
  "https://media.istockphoto.com/photos/mature-indian-couple-hugging-and-looking-at-camera-picture-id1319763174?b=1&k=20&m=1319763174&s=170667a&w=0&h=QuOn6N4K-TMDr6lm_Q_BbrVoMxdpuPJnB-ipU-ZO1ck=",
  influencerTitle: "Clan Q2"
},
{
  id:1,
  link: "/influencer/testimonial",
  imgLink:
    "https://images.unsplash.com/photo-1505535162959-9bbcb4ab22d6?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxleHBsb3JlLWZlZWR8MTF8fHxlbnwwfHx8fA%3D%3D&auto=format&fit=crop&w=700&q=60",
  influencerTitle: "WBHI"
}
],
[
   
  {
   id:2,
  link: "/influencer/testimonial",
  imgLink:
    "https://images.unsplash.com/photo-1640296291688-f67ba0e7c855?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxleHBsb3JlLWZlZWR8MTh8fHxlbnwwfHx8fA%3D%3D&auto=format&fit=crop&w=700&q=60",
  influencerTitle: "Twitch Q1"
},
{
  id:2,
  link: "/influencer/testimonial",
  imgLink:
  "https://images.unsplash.com/photo-1613053342692-d0012e0444eb?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTN8fGluZmx1ZW5jZXJzfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60",
  influencerTitle: "Clan Q2"
},
{
  id:2, 
  link: "/influencer/testimonial",
  imgLink:
    "https://media.istockphoto.com/photos/people-connect-to-the-person-more-than-the-product-picture-id1277414658?b=1&k=20&m=1277414658&s=170667a&w=0&h=4K_sZ8HiESQL8SRYjcdrg28XMm3Di7cDP8SJq6F_TKk=",
  influencerTitle: "WBHI"
}
]
];



let workData=[
  [
    
     {
      id:0,
     link: "/influencer/testimonial",
     imgLink:
     "https://images.unsplash.com/photo-1640289753542-b02666f4a664?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8Nnw0NTE3OTE2fHxlbnwwfHx8fA%3D%3D&auto=format&fit=crop&w=700&q=60",
     influencerTitle: "Twitch Q1"
   },
   {
     id:0,
     link: "/influencer/testimonial",
     imgLink:
       "https://images.unsplash.com/photo-1534008757030-27299c4371b6?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxleHBsb3JlLWZlZWR8Nnx8fGVufDB8fHx8&auto=format&fit=crop&w=700&q=60",
     influencerTitle: "Clan Q2"
   },
   {
     id:0,
     link: "/influencer/testimonial",
     imgLink:
       "https://images.unsplash.com/photo-1615332859295-aa9dc9f01fbc?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxleHBsb3JlLWZlZWR8NXx8fGVufDB8fHx8&auto=format&fit=crop&w=700&q=60",
     influencerTitle: "WBHI"
   }
 ],
 [
   
  {
   id:1,
  link: "/influencer/testimonial",
  imgLink:
    "https://images.unsplash.com/photo-1640327866024-d06817d25393?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxleHBsb3JlLWZlZWR8MTN8fHxlbnwwfHx8fA%3D%3D&auto=format&fit=crop&w=700&q=60",
  influencerTitle: "Twitch Q1"
},
{
  id:1,
  link: "/influencer/testimonial",
  imgLink:
  "https://media.istockphoto.com/photos/mature-indian-couple-hugging-and-looking-at-camera-picture-id1319763174?b=1&k=20&m=1319763174&s=170667a&w=0&h=QuOn6N4K-TMDr6lm_Q_BbrVoMxdpuPJnB-ipU-ZO1ck=",
  influencerTitle: "Clan Q2"
},
{
  id:1,
  link: "/influencer/testimonial",
  imgLink:
    "https://images.unsplash.com/photo-1505535162959-9bbcb4ab22d6?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxleHBsb3JlLWZlZWR8MTF8fHxlbnwwfHx8fA%3D%3D&auto=format&fit=crop&w=700&q=60",
  influencerTitle: "WBHI"
}
]
  
 ];

export {RestData , workData}
